import React, { useEffect, useState } from "react";
import {twillBase} from "../../config/API";

const MegaMenu = () => {
    const [menuData, setMenuData] = useState([]);

    useEffect(() => {
        fetch(`${twillBase}/api/megamenu/`)
            .then((res) => res.json())
            .then((data) => setMenuData(data))
            .catch((err) => console.error("Error fetching menu:", err));
    }, []);

    const clickToggleMenu = (e) => {

        // Get the list element containing the megamenu
        let megaMenuTab = e.target.parentNode.parentNode;
        if(e.target.parentNode.className.includes('site-nav')) {
            megaMenuTab = e.target.parentNode;
        }

        // Close any other open menus except the current one
        const menus = document.getElementsByClassName('menuOpen');
        if(menus && menus.length) {
            Array.from(menus).forEach((menu) => {
                if(megaMenuTab.id !== menu.parentNode.id) {
                    menu.classList.remove('menuOpen')
                    menu.setAttribute('aria-expanded', false);
                    menu.previousSibling.classList.remove('hasOpenMenu');
                    menu.previousSibling.setAttribute('aria-expanded', false);
                }
            })
        }
        // Toggle the class name and aria-expanded of current menu
        if(megaMenuTab && megaMenuTab.children) {
            Array.from(megaMenuTab.children).forEach((element, index) => {
                element.classList.toggle(index === megaMenuTab.children.length - 1 ? 'menuOpen' : 'hasOpenMenu');
                element.setAttribute('aria-expanded', element.getAttribute('aria-expanded') !== 'true');
            })
        }
    }

    return (
            <ul className="megaMenu">
                {menuData.map((menu, menuIndex) => (
                    <li
                        key={menu.id}
                        className="site-nav__menu-item site-nav__menu-item--children"
                        id={`menu-item-${menuIndex}`}
                    >
                        <a
                            className="parentLink"
                            aria-haspopup="true"
                            aria-expanded="false"
                            role = "button"
                            styling="link"
                            tabIndex={menuIndex}
                            onClick={(e) => {
                                    clickToggleMenu(e)
                            }}
                        >
                            <span>{menu.title}</span>
                        </a>
                        <div className="megaMenuWrapper" aria-expanded="false">
                            <div className="container">
                                <ul className="site-nav__menu--primary">
                                    {menu.children.map((childMenu, childMenuIndex) => (

                                    <li
                                        className="site-nav__menu-item site-nav__menu-item--children site-nav__menu-item--child"
                                        id={`menu-item-${menuIndex}_${childMenuIndex}`}
                                    >
                                        <a className="">
                                            <span>{childMenu.content.title}</span>
                                        </a>
                                        {childMenu.children && childMenu.children.length > 0 && (
                                            <ul className="site-nav__menu--secondary">
                                                {childMenu.children.map((child, childIndex) => (
                                                    <li
                                                        key={child.id}
                                                        className="site-nav__menu-item site-nav__menu-item--child"
                                                        id={`menu-item-${menuIndex}_0_${childIndex}`}
                                                    >
                                                        <a
                                                            href={child.content.url}
                                                            className="lastChild"
                                                        >
                                                            <span>{child.content.label}</span>
                                                        </a>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
    );
};

export default MegaMenu;



// WEBPACK FOOTER //
// ./frontend/components/Header/MegaMenu.jsx